const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    gap: 20,
  },
  left: {
    display: "flex",
    alignItems: "center",
    width: "40%",
  },
  center: {
    display: "flex",
    alignItems: "center",
    width: "40%",
    gap: 20,
  },
  right: {
    width: "15%",
  },
  createBtn: {
    borderRadius: "0.5rem",
    padding: "0.44rem 1rem",
    fontWeight: 500,
    width: "138px",
  },
};

export default styles;
